import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import i18n from "../../../i18next";
import { connect } from 'react-redux';

import { loadCustomerInsight } from '../../../actions/restaurants/customerInsight/CustomerInsightAction';
import GeneralValueItem from './GeneralValueItem';
import CustomerInfoDetail from './CustomerInfoDetail';
import TableCard from './TableCard';
import OrderFrequencyDetail from './OrderFrequencyDetail';
import CustomerTimeline from './CustomerTimeline';
import { getPriceWithCurrencySymbol } from '../../../utils/CommonUtils';
import CustomerAddressTable from './CustomerAddressTable';
import CustomInsightsModal from './CustomInsightsModal';
import OrderTypeSearch from './OrderTypeSearch';
import PaymentTypeSearch from './PaymentTypeSearch';
import SourceTypeSearch from './SourceTypeSearch';
import OrderFrequencyHourSearch from './OrderFrequencyHourSearch';
import OrderFrequencyDaySearch from './OrderFrequencyDaySearch';
import ProductSummarySearch from './ProductSummarySearch';
import PromotionSearchSelection from './PromotionSearchSelection';
import CustomerTimelineSearchSelection from './CustomerTimelineSearchSelection';
import CommonMessage from './CommonMessage';

class CustomerInsightScreen extends React.Component {

    state = {
        isAddressModalOpen: false,
        isOrderTypesModalOpen: false,
        isPaymentTypesModalOpen: false,
        isSourceTypesModalOpen: false,
        isOrderFrequencyDayModalOpen: false,
        isOrderFrequencyHourModalOpen: false,
        isProductSummaryModalOpen: false,
        isPromotionModalOpen: false,
        isCustomerTimelineModalOpen: false
    }

    componentDidMount = () => {
        const { id, customerId } = this.props.match.params;
        this.props.loadCustomerInsight(id, customerId);
    }

    toggleAddressModal = () => {
        this.setState({ isAddressModalOpen: !this.state.isAddressModalOpen })
    }

    toggleOrderTypesModal = () => {
        this.setState({ isOrderTypesModalOpen: !this.state.isOrderTypesModalOpen })
    }

    togglePaymentTypesModal = () => {
        this.setState({ isPaymentTypesModalOpen: !this.state.isPaymentTypesModalOpen })
    }

    toggleSourceTypesModal = () => {
        this.setState({ isSourceTypesModalOpen: !this.state.isSourceTypesModalOpen })
    }

    toggelOrderFrequencyDayModal = () => {
        this.setState({ isOrderFrequencyDayModalOpen: !this.state.isOrderFrequencyDayModalOpen })
    }

    toggelOrderFrequencyHourModal = () => {
        this.setState({ isOrderFrequencyHourModalOpen: !this.state.isOrderFrequencyHourModalOpen })
    }

    toggleProductSummaryModal = () => {
        this.setState({ isProductSummaryModalOpen: !this.state.isProductSummaryModalOpen })
    }

    togglePromotionModal = () => {
        this.setState({ isPromotionModalOpen: !this.state.isPromotionModalOpen })
    }

    toggleisCustomerTimelineModal = () => {
        this.setState({ isCustomerTimelineModalOpen: !this.state.isCustomerTimelineModalOpen })
    }

    renderCustomerStatus = () => {
        return (
            <GeneralValueItem
                colSize={2}
                iconSize="80"
                value={this.props.customerInsight.customerStatus}
                valueFontSize={20}
                vip={this.props.customerInsight.vip}
            />
        );
    }

    renderCustomerInfo = () => {
        return (
            <CustomerInfoDetail
                colSize={10}
                sectionTitle={i18n.t('screens:customerInsightScreen.customerInfo')}
                customerInsight={this.props.customerInsight}
                toggleAddressModal={this.toggleAddressModal}
            />
        );
    }

    renderOderTotal = () => {
        return (
            <GeneralValueItem
                colSize={4}
                icon="shopping_cart"
                iconSize="60"
                value={this.props.customerInsight.orderCount}
                label={i18n.t('screens:customerInsightScreen.orders')}
                valueFontSize={26}
            />
        );
    }

    renderOderAverage = () => {
        return (
            <GeneralValueItem
                colSize={4}
                icon="average"
                iconSize="60"
                value={getPriceWithCurrencySymbol(this.props.customerInsight.averageSpent, this.props.restaurant.currency)}
                label={i18n.t('screens:customerInsightScreen.average')}
                valueFontSize={26}
            />
        );
    }

    renderLifetimeTotal = () => {
        return (
            <GeneralValueItem
                colSize={4}
                icon="lifetime"
                iconSize="60"
                value={getPriceWithCurrencySymbol(this.props.customerInsight.lifetimeValue, this.props.restaurant.currency)}
                label={i18n.t('screens:customerInsightScreen.lifetime')}
                valueFontSize={26}
            />
        );
    }

    renderOrderTypesCard = () => {
        return (
            <TableCard
                colSize={4}
                title={i18n.t('screens:customerInsightScreen.orderType')}
                type="orderTypes"
                content={this.props.customerInsight.orderTypeSummaries}
                currency={this.props.restaurant.currency}
                toggleModal={this.toggleOrderTypesModal}
            />
        );
    }

    renderPaymentTypesCard = () => {
        return (
            <TableCard
                colSize={4}
                title={i18n.t('screens:customerInsightScreen.paymentType')}
                type="paymentTypes"
                content={this.props.customerInsight.paymentTypeSummaries}
                currency={this.props.restaurant.currency}
                toggleModal={this.togglePaymentTypesModal}
            />
        );
    }

    renderSourceTypesCard = () => {
        return (
            <TableCard
                colSize={4}
                title={i18n.t('screens:customerInsightScreen.sourceType')}
                type="sourceTypes"
                content={this.props.customerInsight.sourceTypeSummaries}
                currency={this.props.restaurant.currency}
                toggleModal={this.toggleSourceTypesModal}
            />
        );
    }

    renderOrderFrequencyDiagrams = () => {
        return (
            <React.Fragment>
                <OrderFrequencyDetail
                    colSize={5}
                    sectionTitle={i18n.t('screens:customerInsightScreen.orderFrequency')}
                    sectionTitleAddition={i18n.t('screens:customerInsightScreen.byTime')}
                    period="hour"
                    content={this.props.customerInsight.ordersByHourSummaries}
                    toggleModal={this.toggelOrderFrequencyHourModal}
                />
                <OrderFrequencyDetail
                    colSize={5}
                    sectionTitle={i18n.t('screens:customerInsightScreen.orderFrequency')}
                    sectionTitleAddition={i18n.t('screens:customerInsightScreen.byDay')}
                    period="day"
                    content={this.props.customerInsight.ordersByDaySummaries}
                    toggleModal={this.toggelOrderFrequencyDayModal}
                />
            </React.Fragment>
        );
    }

    renderAverageFrequency = () => {
        return (
            <GeneralValueItem
                colSize={2}
                icon="average_frequency"
                iconSize="50"
                value={this.props.customerInsight.frequencyDays}
                label={i18n.t('screens:customerInsightScreen.days')}
                header={i18n.t('screens:customerInsightScreen.averageFrequency')}
                valueFontSize={26}
            />
        );
    }

    renderProductSummary = () => {
        return (
            <TableCard
                colSize={6}
                title={i18n.t('screens:customerInsightScreen.topProducts')}
                type="products"
                content={this.props.customerInsight.productSummaries}
                currency={this.props.restaurant.currency}
                toggleModal={this.toggleProductSummaryModal}
            />
        );
    }

    renderPromotionSummary = () => {
        return (
            <TableCard
                colSize={6}
                title={i18n.t('screens:customerInsightScreen.promotionTimeline')}
                type="promotions"
                content={this.props.customerInsight.promotionSummaries}
                currency={this.props.restaurant.currency}
                toggleModal={this.togglePromotionModal}
            />
        );
    }

    renderCustomerTimeline = () => {
        return (
            <CustomerTimeline
                timeline={this.props.customerInsight.customerTimeline}
                currency={this.props.restaurant.currency}
                toggleModal={this.toggleisCustomerTimelineModal}
            />
        );
    }

    renderAddressModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isAddressModalOpen}
                onToggle={this.toggleAddressModal}
                header={i18n.t('screens:customerInsightScreen.customerAddresses')}
            >
                <CustomerAddressTable addresses={this.props.customerInsight.customerAddresses} />
            </CustomInsightsModal>
        )
    }

    renderOrderTypesModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isOrderTypesModalOpen}
                onToggle={this.toggleOrderTypesModal}
                header={i18n.t('screens:customerInsightScreen.ordersOrderType')}
            >
                <OrderTypeSearch restaurantId={this.props.match.params.id} customerId={this.props.match.params.customerId} />
            </CustomInsightsModal>
        )
    }

    renderPaymentTypesModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isPaymentTypesModalOpen}
                onToggle={this.togglePaymentTypesModal}
                header={i18n.t('screens:customerInsightScreen.ordersPaymentType')}
            >
                <PaymentTypeSearch restaurantId={this.props.match.params.id} customerId={this.props.match.params.customerId} />
            </CustomInsightsModal>
        )
    }

    renderSourceTypesModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isSourceTypesModalOpen}
                onToggle={this.toggleSourceTypesModal}
                header={i18n.t('screens:customerInsightScreen.ordersSourceType')}
            >
                <SourceTypeSearch restaurantId={this.props.match.params.id} customerId={this.props.match.params.customerId} />
            </CustomInsightsModal>
        )
    }

    renderOrderFrequencyDayModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isOrderFrequencyDayModalOpen}
                onToggle={this.toggelOrderFrequencyDayModal}
                header={i18n.t('screens:customerInsightScreen.orderFrequency')}
            >
                <OrderFrequencyDaySearch restaurantId={this.props.match.params.id} customerId={this.props.match.params.customerId} />
            </CustomInsightsModal>
        )
    }

    renderOrderFrequencyHourModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isOrderFrequencyHourModalOpen}
                onToggle={this.toggelOrderFrequencyHourModal}
                header={i18n.t('screens:customerInsightScreen.orderFrequency')}
            >
                <OrderFrequencyHourSearch restaurantId={this.props.match.params.id} customerId={this.props.match.params.customerId} />
            </CustomInsightsModal>
        )
    }

    renderProductSummaryModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isProductSummaryModalOpen}
                onToggle={this.toggleProductSummaryModal}
                header={i18n.t('screens:customerInsightScreen.productSummary')}
            >
                <ProductSummarySearch restaurantId={this.props.match.params.id} customerId={this.props.match.params.customerId} />
            </CustomInsightsModal>
        )
    }

    renderPromotionModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isPromotionModalOpen}
                onToggle={this.togglePromotionModal}
                header={i18n.t('screens:customerInsightScreen.promotionSummary')}
            >
                <PromotionSearchSelection restaurantId={this.props.match.params.id} customerId={this.props.match.params.customerId} />
            </CustomInsightsModal>
        )
    }

    renderCustomerTimelineModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isCustomerTimelineModalOpen}
                onToggle={this.toggleisCustomerTimelineModal}
                header={i18n.t('screens:customerInsightScreen.customerTimeline')}
            >
                <CustomerTimelineSearchSelection restaurantId={this.props.match.params.id} customerId={this.props.match.params.customerId} />
            </CustomInsightsModal>
        )
    }

    renderCustomerInsight = () => {
        const { mainContainer, rowStyle } = styles;

        return (
            <React.Fragment>
                <Container fluid style={mainContainer}>
                    <Row style={rowStyle}>
                        <Col sm={7}>
                            <Row>
                                {this.renderCustomerStatus()}
                                {this.renderCustomerInfo()}
                            </Row>
                        </Col>
                        <Col sm={5}>
                            <Row>
                                {this.renderOderTotal()}
                                {this.renderOderAverage()}
                                {this.renderLifetimeTotal()}
                            </Row>
                        </Col>
                    </Row>
                    <Row style={rowStyle}>
                        <Col sm={7}>
                            <Row>
                                {this.renderOrderTypesCard()}
                                {this.renderPaymentTypesCard()}
                                {this.renderSourceTypesCard()}
                            </Row>
                            <Row>
                                {this.renderOrderFrequencyDiagrams()}
                                {this.renderAverageFrequency()}
                            </Row>
                            <Row>
                                {this.renderProductSummary()}
                                {this.renderPromotionSummary()}
                            </Row>
                        </Col>
                        <Col sm={5}>
                            <Row>
                                {this.renderCustomerTimeline()}
                            </Row>
                        </Col>
                    </Row>
                </Container>
                {this.renderAddressModal()}
                {this.renderOrderTypesModal()}
                {this.renderPaymentTypesModal()}
                {this.renderSourceTypesModal()}
                {this.renderOrderFrequencyHourModal()}
                {this.renderOrderFrequencyDayModal()}
                {this.renderProductSummaryModal()}
                {this.renderPromotionModal()}
                {this.renderCustomerTimelineModal()}
            </React.Fragment>
        )
    }



    render() {

        if (this.props.customerInsight.insightEnabled === null) {
            return null;
        } else if (this.props.customerInsight.insightEnabled) {
            return this.renderCustomerInsight();
        } else {
            return <CommonMessage message={i18n.t('screens:customerInsightScreen.customerInsightDisabled')} />;
        }

    }
}

const mapStateToProps = state => {
    return {
        customerInsight: state.customerInsight,
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, { loadCustomerInsight })(CustomerInsightScreen);

const styles = {
    mainContainer: {
        backgroundColor: 'rgb(235,240,244)',
        padding: '0',
        marginTop: '10px'
    },
    rowStyle: {
        margin: '0'
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/CustomerInsightScreen.js